<template>
    <common-promise class="the-document-entries" :promise="getProductInfolist">
        <template #default="{ data }">
            <the-document-entry
                v-for="(entry,key,index) in data"
                :key="index"
                class="entry"
                :entryType="key"
                :entry="entry"
            ></the-document-entry>
        </template>
    </common-promise>
</template>

<script>
import CommonPromise from '../../../../components/common/common-promise';
import { getProductInfolist } from '../../service';
import TheDocumentEntry from './the-document-entry';

export default {
    name: 'TheDocumentEntries',
    components: { TheDocumentEntry, CommonPromise },
    data() {
        return {
            getProductInfolist
        };
    },

    methods: {
        name() {}
    }
};
</script>

<style lang="scss" scoped>
.the-document-entries {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 60px;
    padding-bottom: 150px;
}
</style>
